import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
    POST_ON_CALL_POLICY,
    GET_ON_CALL_POLICY,
    GET_SPECIFIC_ON_CALL_POLICY,
    EDIT_ON_CALL_POLICY,
    DELETE_SPECIFIC_ON_CALL_POLICY,
    GET_ONCALL_ELIGIBLE_USERS
} from "./actionTypes";

import {
    postOnCallPolicySuccess, postOnCallPolicyFail, getOnCallPoliciesSuccess, getOnCallPoliciesFail, getSpecificOnCallPolicySuccess, getSpecificOnCallPolicyFail, editOnCallPolicySuccess, editOnCallPolicyFail, deleteSpecificOnCallPolicySuccess, deleteSpecificOnCallPolicyFail, getOncallEligibleUsersSuccess, getOncallEligibleUsersFail
} from "./actions";

import {
    postOnCallPolicyUrl, getOnCallPolicyUrl, getSpecificOnCallPolicyUrl, editOnCallPolicyUrl, deleteSpecificOnCallPolicyUrl, getOncallEligibleUsersUrl
} from "../../helpers/fakebackend_helper";

import { showNotification } from "components/Common/notification";
import { func } from "prop-types";

function* onGetOnCallPolicies() {
    try {
        const response = yield call(getOnCallPolicyUrl);
        yield put(getOnCallPoliciesSuccess(response));
    } catch (error) {
        yield put(getOnCallPoliciesFail(error.message));
    }
}

function* onGetOnCallPoliciesByID(policy_id) {
    try {
        const response = yield call(getSpecificOnCallPolicyUrl, policy_id.payload);
        yield put(getSpecificOnCallPolicySuccess(response));
    } catch (error) {
        yield put(getSpecificOnCallPolicyFail(error.message));
    }
}

function* onDeleteOnCallPoliciesByID({ payload: { oncall_policy_id } }) {
    try {
        const response = yield call(deleteSpecificOnCallPolicyUrl, {
            oncall_policy_id: oncall_policy_id
        });
        if (response) {
            showNotification("success", "Policy successfully deleted!");
            yield put({ type: GET_ON_CALL_POLICY });
        }
        yield put(deleteSpecificOnCallPolicySuccess(response));
    } catch (error) {
        if (error) {
            showNotification("error", "Policy not deleted since policy is in use by an Application Service.");
        }
        yield put(deleteSpecificOnCallPolicyFail(error.message));
    }
}

function* onCreatingOnCallPolicy({ payload: { name, timezone,repeat_escalation_policy, rotation_list } }) {
    try {
        const response = yield call(postOnCallPolicyUrl, {
            name: name,
            timezone: timezone,
            repeat_escalation_policy: repeat_escalation_policy,
            rotation_list: rotation_list
        });
        yield put(postOnCallPolicySuccess(response));
        if (response) {
            showNotification("success", "On-Call Policy successfully added")
            window.location.href='/oncall-policies'
        }
    } catch (error) {
        yield put(postOnCallPolicyFail(error.message));
    }
}

function* onEditingOnCallPolicy({ payload: { oncall_policy_id, name, timezone,repeat_escalation_policy, rotation_list,rotationsToBeDeleted } }) {
    try {
        const response = yield call(editOnCallPolicyUrl, {
            oncall_policy_id: oncall_policy_id,
            name: name,
            timezone: timezone,
            repeat_escalation_policy: repeat_escalation_policy,
            rotation_list: rotation_list,
            rotation_ids_to_delete: rotationsToBeDeleted
        });
        yield put(editOnCallPolicySuccess(response));
        if (response) {
            showNotification("success", "On-Call Policy successfully updated")
            window.location.reload()
        }
    } catch (error) {
        yield put(editOnCallPolicyFail(error.message));
    }
}

function* onGetOncallEligibleUsers() {
    try {
        const response = yield call(getOncallEligibleUsersUrl);
        yield put(getOncallEligibleUsersSuccess(response));
    } catch (error) {
        yield put(getOncallEligibleUsersFail(error.message));
    }
}

function* onCallPolicySaga() {
    yield takeEvery(POST_ON_CALL_POLICY, onCreatingOnCallPolicy);
    yield takeEvery(GET_ON_CALL_POLICY, onGetOnCallPolicies);
    yield takeEvery(GET_SPECIFIC_ON_CALL_POLICY, onGetOnCallPoliciesByID);
    yield takeEvery(DELETE_SPECIFIC_ON_CALL_POLICY, onDeleteOnCallPoliciesByID);
    yield takeEvery(EDIT_ON_CALL_POLICY, onEditingOnCallPolicy);
    yield takeEvery(GET_ONCALL_ELIGIBLE_USERS, onGetOncallEligibleUsers);
}

export default onCallPolicySaga;